import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';

@Injectable({
    providedIn: 'root'
})
export class InteractionService {

    constructor(private readonly dialog: MatDialog) { }

    showModal(component: any, data?: any) {
        return this.dialog
            .open(component, {data, disableClose: true})
            .afterClosed();
    }

}
